<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-4">
                  <label>Sub Grupo</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="sub_grupo.nome"
                  />
                </div>
                <div class="col-md-4">
                  <label>Grupo</label>
                  <v-select
                    v-model="sub_grupo.grupo_id"
                    class="vselect"
                    :options="grupos"
                    :reduce="(grupos) => grupos.id"
                    :label="'nome'"
                  />
                </div>
                <div class="col-md-4">
                  <label> Status </label>
                  <select v-model="sub_grupo.ativo" class="form-control">
                    <option :value="1">Ativo</option>
                    <option :value="0">Inativo</option>
                  </select>
                </div>
                <div class="col-md-12">
                  <label>Descrição</label>
                  <textarea
                    cols="30"
                    rows="10"
                    class="form-control"
                    v-model="sub_grupo.descricao"
                  ></textarea>
                </div>
                <div class="col-md-12 text-right">
                  <hr />
                  <router-link to="/sub_grupos" class="btn btn-back mr-1">
                    <i class="fa fa-arrow-left" />
                    Voltar
                  </router-link>
                  <a class="btn btn-add" @click="save">
                    Salvar
                    <i class="fa fa-save" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      sub_grupo: {},
      grupos: [],
    };
  },
  computed: {},
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "sub_grupos";

      if (self.sub_grupo.id) {
        api += "/" + self.sub_grupo.id;
        self.sub_grupo._method = "PUT";
      }

      axios
        .post(api, self.sub_grupo)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/sub_grupos");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getSubGrupo: function (id) {
      const self = this;
      const api = self.$store.state.api + "sub_grupos/" + id;

      axios
        .get(api)
        .then((response) => {
          self.sub_grupo = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getGrupos: function (id) {
      const self = this;
      const api = self.$store.state.api + "grupos?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.grupos = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    self.getGrupos();

    let id = self.$route.params.id;
    if (id) {
      self.getSubGrupo(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>